import { Swiper, Navigation, Autoplay, Pagination } from 'swiper';

export default class SliderMartin {

  static init(swiperContainer) {
    return new SliderMartin(swiperContainer);
  }

  static initAll() {
    const swiperContainers = document.querySelectorAll('.slider-martin');

    const sliderMartinInstances = [];
    swiperContainers.forEach((swiperContainer) => {
      sliderMartinInstances.push(SliderMartin.init(swiperContainer));
    });

    return sliderMartinInstances;
  }

  constructor(swiperContainer) {

    const swiperElement = swiperContainer.querySelector('.swiper');
    this.swiperDelay = swiperContainer.getAttribute('data-slider-delay');

    this.slider = new Swiper(swiperElement, {
      modules: [Navigation, Autoplay, Pagination],
      speed: 1000,
      autoHeight: true,
      centeredSlides: true,
      spaceBetween: 20, // in px
      loop: true,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination-martin',
        type: 'bullets',
        clickable: true,
      },
      autoplay: {
        delay: this.swiperDelay * 1000, // in milliseconds
        disableOnInteraction: false
      },

      // Navigation arrows
      navigation: {
        nextEl: swiperContainer.querySelector('.swiper-button-next-martin'),
        prevEl: swiperContainer.querySelector('.swiper-button-prev-martin'),
      },
    });
  }
}